import propTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { open } from '../../../modules/modal/actions';
import { getWithdrawPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/withdrawBackup.json';

export const LearnMoreNote = ({ openModal, contentStackContent }) => {
  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = backupContent;
  }
  return (
    <div className="omni-learn-more">
      <span dangerouslySetInnerHTML={{ __html: content.request.dailyLimitText }} />
      <span className="omni-learn-more__clickable" onClick={openModal} dangerouslySetInnerHTML={{ __html: content.learnMoreText }} />
    </div>
  );
};

LearnMoreNote.propTypes = {
  openModal: propTypes.func.isRequired,
  contentStackContent: propTypes.object
};

const mapDispatchToProps = {
  openModal: open.bind(null, { componentName: 'WithdrawalInfo' })
};

const mapStateToProps = state => ({
  contentStackContent: getWithdrawPage(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(LearnMoreNote);
